import * as React from 'react'
import { Alert } from 'react-bootstrap'
import ItemRow from '../../../../common/ItemRow'

interface BadUrlProps {
	badUrlMsg: string[]
	offset?: number
}

const BadUrlAlert: React.FunctionComponent<BadUrlProps> = (props) => {
	const plural = props.badUrlMsg.length > 1 ? 's' : ''
	const auxiliaryVerb = props.badUrlMsg.length > 1 ? 'are' : 'is'
	return (
		<ItemRow name="badUrlAlert" description="" offset={props.offset}>
			<Alert bsStyle="danger">
				We couldn't import content for the URL
				{plural} you provided:
				{props.badUrlMsg.map((m, i) => (
					<span key={i}>
						<br />
						{m}
					</span>
				))}
				<br />
				<p>
					Please make sure the url{plural} {auxiliaryVerb} correct. <br />
					You can fill the ad fields manually.
				</p>
			</Alert>
		</ItemRow>
	)
}

export default BadUrlAlert
